/* Badge de créditos — topo direita do chat */
import React from 'react';
import type { CreditsInfo } from '../types';

interface CreditsBadgeProps {
  creditsInfo: CreditsInfo | null;
  /** Função de tradução */
  t: (key: string, vars?: Record<string, string | number>) => string;
}

/** Nome do tier formatado para exibição */
function tierLabel(tier: CreditsInfo['tier']): string {
  switch (tier) {
    case 'plantonista': return 'PLANTONISTA';
    case 'especialista': return 'ESPECIALISTA';
    case 'unlimited': return 'UNLIMITED';
    default: return 'FREE';
  }
}

export function CreditsBadge({ creditsInfo, t }: CreditsBadgeProps) {
  if (!creditsInfo) {
    return null;
  }

  const { credits, tier, isTrial } = creditsInfo;
  const isExhausted = credits <= 0;

  // Determina estilo do badge — kit Claude Design (repouso limpo, sem glow neon).
  // Esgotado = CTA azul "assinar"; com créditos = acento violeta.
  const badgeColor = isExhausted ? '#7FB0FF' : 'var(--violet)';
  const badgeBorder = isExhausted ? 'var(--cta-blue)' : 'var(--violet)';

  // Texto do badge
  let badgeText: string;
  if (isExhausted) {
    badgeText = t('credits.badge.exhausted');
  } else if (isTrial) {
    badgeText = t('credits.badge.trial', { credits });
  } else {
    badgeText = t('credits.badge.paid', {
      credits: credits % 1 === 0 ? credits : credits.toFixed(1),
      tier: tierLabel(tier),
    });
  }

  return (
    <div
      data-onboarding="credits-badge"
      aria-label={`Créditos: ${badgeText}`}
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: '12px',
        fontWeight: 600,
        color: badgeColor,
        boxShadow: 'none',
        border: `1px solid ${badgeBorder}`,
        padding: '8px 12px',
        borderRadius: '2px',
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
        minHeight: '46px',
        display: 'inline-flex',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}
    >
      {badgeText}
    </div>
  );
}
